// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const taskSchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),
  userId: z.string().max(100).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  extended: z.record(z.string(), z.unknown()).optional(),
  name: z.string().max(500).optional(),
  title: z.string().max(500),
  description: z.string().max(100000).optional(),
  dueAt: z.string().max(200).datetime().optional(),
  startAt: z.string().max(200).datetime().optional(),
  startedAt: z.string().max(200).datetime().optional(),
  completedAt: z.string().max(200).datetime().optional(),
  status: z.string().max(50).default('todo').optional(),
  type: z.string().max(200).optional(),
  completed: z.boolean().optional(),
  projectId: z.string().max(100).optional(),
  milestoneId: z.string().max(100).optional(),
  parentTaskId: z.string().max(100).optional(),
  archived: z.boolean(),
  timeBudgetHours: z.number().optional(),
  isRecurring: z.boolean().optional(),
  recurrenceRule: z.string().max(200).optional(),
  parentRecurrenceId: z.string().max(100).optional(),
  recurrenceInstanceDate: z.string().max(200).datetime().optional(),
  categoryId: z.string().max(100).optional(),
  tagIds: z.array(z.string()).optional(),
  priority: z.number().int().min(0).max(4).optional(),
  assigneeId: z.string().max(100).optional(),
  estimatePoints: z.number().min(0).max(10000).multipleOf(0.5).optional(),
  sortOrder: z.number().int().min(0).max(999999).optional(),
  version: z.number().int().min(1).max(9999999),
  tenantId: z.string().max(100).optional(),
})

export type TaskInput = z.infer<typeof taskSchema>
